"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateOrderValidationSchema = exports.CreateOrderValidationSchema = void 0;
const Yup = __importStar(require("yup"));
const REQUIRED_FIELD = 'Este campo é obrigatório';
exports.CreateOrderValidationSchema = Yup.object({
    flight_date: Yup.date().required(REQUIRED_FIELD),
    airline: Yup
        .string()
        .required(REQUIRED_FIELD),
    reservation_code: Yup
        .string()
        .required(REQUIRED_FIELD),
    amount: Yup
        .number()
        .min(1, 'O valor deve ser maior que zero')
        .required(REQUIRED_FIELD),
    pax: Yup
        .number()
        .min(1, 'O valor deve ser maior que zero')
        .required(REQUIRED_FIELD),
    fees: Yup
        .number()
        .min(0, REQUIRED_FIELD)
        .required(REQUIRED_FIELD),
    additional_cost: Yup
        .number()
        .min(0, REQUIRED_FIELD)
        .optional(),
    card_id: Yup
        .number()
        .min(0, REQUIRED_FIELD)
        .required(REQUIRED_FIELD),
    sell_price: Yup
        .number()
        .min(0, REQUIRED_FIELD)
        .required(REQUIRED_FIELD),
});
exports.UpdateOrderValidationSchema = Yup.object({
    flight_date: Yup.date().required(REQUIRED_FIELD),
    airline: Yup
        .string()
        .required(REQUIRED_FIELD),
    reservation_code: Yup
        .string()
        .required(REQUIRED_FIELD),
    amount: Yup
        .number()
        .min(1, 'O valor deve ser maior que zero')
        .required(REQUIRED_FIELD),
    pax: Yup
        .number()
        .min(1, 'O valor deve ser maior que zero')
        .required(REQUIRED_FIELD),
    fees: Yup
        .number()
        .min(0, REQUIRED_FIELD)
        .required(REQUIRED_FIELD),
    additional_cost: Yup
        .number()
        .min(0, REQUIRED_FIELD)
        .optional(),
    card_id: Yup
        .number()
        .min(0, REQUIRED_FIELD)
        .required(REQUIRED_FIELD),
    sell_price: Yup
        .number()
        .min(0, REQUIRED_FIELD)
        .required(REQUIRED_FIELD),
});
